import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=8b9bfcf2&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=8b9bfcf2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9bfcf2",
  null
  
)

export default component.exports